import './preprocessDysonSpiral';
import { memo, useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { useAsset } from '@artica/assets';
import { spriteSpiral } from '../../common/formatSpiral';

export default memo(function Spiral() {
  const spiral = useAsset('spiral_dyson');
  const { spriteMat } = spiral;
  const dotSprite = spriteMat.map = useAsset('dot_sprite_3');

  spriteSpiral(spiral, dotSprite, [
    { children: spiral.children[1].children, count: 200, scale: 30, offset: { x: 0, y: 0, z: -0.1 }, genOffset: -0.5, slide: 0 },
    { children: spiral.children[1].children, count: 1, scale: 30, offset: { x: 0, y: 0, z: 0 }, genOffset: 0, slide: 0 },
    { children: spiral.children[1].children, count: 100, scale: 30, offset: { x: 0, y: -0.1, z: 0 }, genOffset: 0, slide: 0.05 },
  ]);

  const ref = useRef();

  useFrame(() => {
    const obj = ref.current;
    if (!obj) return;

    const rotY = obj.rotation.y + 0.001 / Math.PI;
    obj.rotation.y = rotY;
  });

  return (
    <primitive
      ref={ ref }
      object={ spiral }
      scale={ 4 }
    />
  );
});